export const blockIconsCommunicationForwardToInboxNew = (
	<span className='material-symbols-outlined'>forward_to_inbox</span>
);
